// extracted by mini-css-extract-plugin
export var container = "IconGrid-module--container--yUelW";
export var coloredWord = "IconGrid-module--coloredWord--29xEU";
export var itemWrapper = "IconGrid-module--itemWrapper--18yFV";
export var item = "IconGrid-module--item--2AhYb";